import request from '@/utils/request'

export function findUserPage(data) {
  return request({
    url: '/admin/system/sysUser/findPage',
    method: 'post',
    data: data
  })
}
/**
 * 根据userId获取sysUser
 */
export function getUserRoleInfoByUserId(data) {
  return request({
    url: '/admin/system/sysUser/getUserRoleInfoByUserId',
    method: 'post',
    data: data
  })
}
export function updateUserState(data) {
  return request({
    url: '/admin/system/sysUser/updateState',
    method: 'post',
    data: data
  })
}

export function updateUserRoleRel(data) {
  return request({
    url: '/admin/system/sysUser/updateUserRoleRel',
    method: 'post',
    data: data
  })
}
/**
 * 修改密码
 */
export function updatePassWord(data) {
  return request({
    url: '/admin/system/sysUser/updatePassWord',
    method: 'post',
    data: data
  })
}
/**
 * 增加或者修改用户
 */
export function saveOrUpdateUser(data) {
  return request({
    url: '/admin/system/sysUser/saveOrUpdate',
    method: 'post',
    data: data
  })
}
/**
 * 根据id删除用户
 */
export function deleteUserById(data) {
  return request({
    url: '/admin/system/sysUser/deleteById',
    method: 'post',
    data: data
  })
}

/**
 * 根据id获取用户
 */
export function getUserById(data) {
  return request({
    url: '/admin/system/sysUser/getById',
    method: 'post',
    data: data
  })
}

export function changePassword(data) {
  return request({
    url: '/admin/system/sysUser/changePassword',
    method: 'post',
    data: data
  })
}

export function saveUserTruckRel(data) {
  return request({
    url: '/admin/system/sysUser/saveUserTruckRel',
    method: 'post',
    data: data
  })
}

export function queryUserTruckRels(data) {
  return request({
    url: '/admin/system/sysUser/queryUserTruckRels',
    method: 'post',
    data: data
  })
}

/**
 * 用户类型
 */
export const userType = { 1: '开发人员', 3: '管理员', 31: '普通用户' }
// export const userType = { 1: '开发人员', 3: '管理员', 5: '国氢分部管理员', 7: '企业/车队管理员', 31: '国氢总公司普通用户', 51: '国氢分部普通用户', 71: '企业/车队普通用户' }



// WEBPACK FOOTER //
// ./src/api/user/user.js